<template>
  <div v-if="$route.name != 'Articulos'">
    <v-tooltip bottom v-if="!$vuetify.breakpoint.smAndDown">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          color="red darken-3"
          bottom
          right
          absolute
          :loading="downloadpdf"
          x-small
          @click="getFicha()"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon size="28">mdi-file-pdf-box</v-icon>
        </v-btn>
      </template>
      <span>Descargar Catalogo PDF</span>
    </v-tooltip>
    <v-snackbar v-model="dialog" :timeout="timeout">
      {{ text }}

      <template v-slot:actions>
        <v-btn color="blue" variant="text" @click="salir()"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";

import marcasFiltroImg from "../components/ListaMarcasImg.vue";
export default {
  data() {
    return {
      text: "Sub Categoria Sin Ficha Técnica!",
      timeout: 1500,
      dialog: false,
      selectedItem: null,
      overlay: false,
      downloadpdf: false,
      itemsel: null,
    };
  },
  components: {
    marcasFiltroImg,
  },

  computed: {
    ...mapGetters(["filterconsolidado"]),
    ...mapState([
      "ttFichaTecnica",
      "publicPath",
      "dirPHP",
      "dirTemp",
      "SubCategorias",
      "CodMarcaPdf",
      "dataUser",
      "imgPeque",
      "imgMarcas",
      "ttMarcas",
      "ttArticuloAll",
      "CodMarcaPdf",
      "tipoMoneda",
      "simboloMoneda",
      "filter",
    ]),
    nombreSCat: function () {
      return function (id, idscat) {
        if (this.SubCategorias) {
          var nb = this.SubCategorias.filter(
            (x) =>
              x.Categoria === id &&
              x.SubCategoria === idscat &&
              x.SubCategoria != 0
          ).map((x) => x.Nombre);
          return nb.toString();
        }
      };
    },
    ttSubCat: {
      get: function () {
        if (this.CodMarcaPdf === 0)
          return (this.uniqueArray = [
            ...new Set(
              this.ttArticuloAll.filter(
                (x) => x.SubCategoria != 0 && x.TipoProd === "Maquina"
              )
            ),
          ]);
        else {
          return (this.uniqueArray = [
            ...new Set(
              this.ttArticuloAll.filter(
                (x) =>
                  x.SubCategoria != 0 &&
                  this.CodMarcaPdf === x.Marca &&
                  x.TipoProd === "Maquina"
              )
            ),
          ]);
        }
        /*
                  filter(function(value, index, self) { 
  return self.indexOf(value) === index;
});
                  */
      },
    },
    SubCategoriasNew: function () {
      return function (id) {
        let datos = [];
        if (this.SubCategorias) {
          if (id.length === 1) {
            datos[0] = this.SubCategorias.filter(
              (x) => x.SubCategoria != 0 && x.SubCategoria === id[0]
            );
          } else {
            for (let i = 0; i < id.length; i++) {
              datos[i] = this.SubCategorias.filter(
                (x) => x.SubCategoria != 0 && x.SubCategoria === id[i]
              );
            }
          }
          return datos.filter((x) => x != null);
        }
      };
    },
    /* SubCategoriasNew:{
            get: function() {
                if(this.SubCategorias)
                return this.SubCategorias.filter(x=>x.SubCategoria!=0)
            }
        },*/
    ttCategoriaNew: {
      get: function () {
        let uniqueArray = [];
        if (this.ttSubCat) {
          uniqueArray = [
            ...new Set(
              this.ttSubCat
                .filter((x) => x.SubCategoria != 0)
                .map((x) => x["SubCategoria"])
            ),
          ];
          return uniqueArray.sort((a, b) => a - b);
          // return this.uniqueArray = [... new Set(this.ttSubCat.filter(x => x.SubCategoria!=0))];
        }
      },
    },
  },
  methods: {
    ...mapMutations(["CLR_CodMarcaPdf", "clrTtFichaTecnica"]),
    ...mapActions(["datosFichaTec"]),
    async getFicha() {
      this.downloadpdf = true;
      this.clrTtFichaTecnica();
      const arrArt = this.filterconsolidado.map((item) => item.Codigo);

      for (const item of arrArt) await this.datosFichaTec({ codart: item });
      this.ttFichaTecnica.length > 0
        ? await this.PdfCatalogo()
        : this.abrirDlg();
    },
    abrirDlg() {
      this.dialog = true;
      this.downloadpdf = false;
    },
    async PdfCatalogo() {
      const url = `pdf/catalogopdf.php`;
      const api = `${this.dirTemp}${url}`;
      const { codscat, codcat } = this.filter;
      const xdata = {
        dsCatalogo: {
          ttArticulos: this.filterconsolidado,
          ttFichaTecnica: this.ttFichaTecnica.flat(),
        },
      };

      const data = {
        cat: codcat,
        subcat: codscat,
        usuario: this.dataUser.Usuario,
        idmarca: this.CodMarcaPdf ? this.CodMarcaPdf : 0,
        incluyepext: this.dataUser.IndVerPreciosExt,
        nombresubcat: this.nombreSCat(codcat, codscat),
        dirimg: this.imgPeque,
        dirmarcas: this.imgMarcas,
        verprecios: this.dataUser.VerPrecios[this.tipoMoneda],
        data: xdata,
      };
      try {
        const abortController = new AbortController();
        const { signal } = abortController;

        const res = await fetch(api, {
          method: "POST",
          signal,
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });
        if (!res.ok) {
          const err = new Error("Error en la peticion Fetch");
          err.status = res.status || "00";
          err.statusText = res.statusText || "Ocurrio un Error";
          throw err;
        }
        const resp = await res.arrayBuffer();
        if (!signal.aborted) {
          const file = new Blob([resp], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = fileURL;
          link.download = this.nombreSCat(codcat, codscat) + ".pdf";
          link.click();
        }
      } catch (e) {
        console.log("Error:", e);
      } finally {
        this.downloadpdf = false;
      }
    },

    salir() {
      this.dialog = false;
      this.selectedItem = null;
      this.CLR_CodMarcaPdf();
    },
  },
};
</script>

<style></style>
